/**
 * Breadcrumbs — location context bar shown under the header/module bar on
 * every content page. Derives the trail from the active route.
 */
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { findPage, prettify } from './modulesConfig';

const Breadcrumbs = () => {
  const location = useLocation();
  const page = findPage(location.pathname);

  return (
    <div className="sticky top-[64px] z-20 bg-white/80 backdrop-blur-md border-b border-gray-200 px-6 py-2.5 flex items-center gap-2">
      <nav className="flex items-center gap-1.5 text-sm text-gray-500 min-w-0" data-testid="breadcrumbs">
        <Link
          to="/"
          className="hover:text-gray-800 flex items-center gap-1 shrink-0"
          data-testid="breadcrumb-link-home"
        >
          <Home className="w-3.5 h-3.5" strokeWidth={1.5} />
          Home
        </Link>
        {page && (
          <>
            <ChevronRight className="w-3.5 h-3.5 text-gray-300 shrink-0" />
            <span className="shrink-0">{prettify(page.moduleTitle)}</span>
            {page.group && (
              <>
                <ChevronRight className="w-3.5 h-3.5 text-gray-300 shrink-0" />
                <span className="truncate">{page.group}</span>
              </>
            )}
            <ChevronRight className="w-3.5 h-3.5 text-gray-300 shrink-0" />
            <span className="text-gray-800 font-medium truncate" data-testid="breadcrumb-current">
              {page.label}
            </span>
          </>
        )}
      </nav>
    </div>
  );
};

export default Breadcrumbs;
